import { render, staticRenderFns } from "./AfaEdit.vue?vue&type=template&id=132e1434"
import script from "./AfaEdit.vue?vue&type=script&lang=js"
export * from "./AfaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports